import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/tarifas-isr-tipos-de-nominas-empleados';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * Get Tarifas ISR Tipo de  Nomina Empleado
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTarifasISRTipoNominaEmpleado = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tarifa ISR Tipo de  Nomina Empleado
 * @params {number} id
 * @returns {Promise<object|null>};
 */
export const getTarifaISRTipoNominaEmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tarifa ISR Tipo de  Nomina Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTarifaISRTipoNominaEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tarifa ISR Tipo de  Nomina Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTarifaISRTipoNominaEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tarifa ISR Tipo de  Nomina Empleado
 * @param {number} id
 * @return {Promise<boolean>}
 */
export const deleteTarifaISRTipoNominaEmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
